(function(){
  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  function $all(sel, ctx){ return Array.from((ctx||document).querySelectorAll(sel)); }

  // JSONP helper fallback for endpoints that don't allow CORS (e.g., some Google Apps Script configs)
  function jsonpRequest(url, params, onSuccess, onError){
    var callbackName = 'backInStockCallback_' + Math.random().toString(36).slice(2);
    var timer = null;
    window[callbackName] = function(data){
      try { onSuccess && onSuccess(data); } finally { cleanup(); }
    };
    function cleanup(){
      try { delete window[callbackName]; } catch(e){}
      var s = document.getElementById(callbackName);
      if (s && s.parentNode) s.parentNode.removeChild(s);
      if (timer) { clearTimeout(timer); timer = null; }
    }
    var qs = Object.keys(params || {}).map(function(k){
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k] == null ? '' : params[k]);
    }).join('&');
    var src = url + (url.indexOf('?') === -1 ? '?' : '&') + qs + '&callback=' + callbackName;
    var s = document.createElement('script');
    s.src = src;
    s.id = callbackName;
    s.onerror = function(){ cleanup(); onError && onError(new Error('JSONP load error')); };
    document.head.appendChild(s);

    // Timeout: if no response within 8s, treat as failure
    timer = setTimeout(function(){
      cleanup();
      onError && onError(new Error('JSONP timeout'));
    }, 8000);

    return function(){ cleanup(); };
  }

  function initForm(form){
    if (form.__bis_init) return; form.__bis_init = true;
    var endpoint = form.getAttribute('data-endpoint') || '';
    var msgEl = form.querySelector('[aria-live]') || form.querySelector('.message') || form.querySelector('.back-in-stock-message') || form.querySelector('.revendedor-message');
    if (!msgEl){ msgEl = document.createElement('p'); msgEl.setAttribute('aria-live','polite'); msgEl.className = 'message'; var actions = form.querySelector('.revendedor__actions, .back-in-stock__actions, .actions'); if (actions) actions.appendChild(msgEl); else form.appendChild(msgEl); }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      msgEl.textContent = '';

      // Validate required fields generically
      var required = Array.from(form.querySelectorAll('[required]'));
      var missing = required.filter(function(el){ return !(el.value && el.value.toString().trim()); });
      if (missing.length){
        msgEl.textContent = 'Por favor preencha os campos obrigatórios.';
        (missing[0] && missing[0].focus());
        return;
      }

      // Collect all named form fields into payload
      var payload = {};
      Array.from(form.elements).forEach(function(el){
        if (!el.name) return;
        if (el.tagName === 'BUTTON' || el.type === 'submit' || el.disabled) return;
        if (el.type === 'checkbox' || el.type === 'radio'){
          if (!el.checked) return;
        }
        payload[el.name] = el.value == null ? '' : el.value;
      });

      // Add metadata
      payload.shop = payload.shop || window.location.hostname;
      payload.created_at = new Date().toISOString();

      var btn = form.querySelector('button[type=submit]');
      if (btn) btn.disabled = true;

      if (!endpoint){
        msgEl.textContent = 'Configure o endpoint nas configurações do tema para receber os dados.';
        if (btn) btn.disabled = false;
        return;
      }

      console.log('Form submit', { endpoint: endpoint, payload: payload });

      // Primeiro: tente enviar como form-urlencoded (evita preflight CORS na maioria dos casos)
      msgEl.textContent = 'Aguarde, enviando...';
      var bodyParams = new URLSearchParams();
      Object.keys(payload).forEach(function(k){ bodyParams.append(k, payload[k] == null ? '' : payload[k]); });

      fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        body: bodyParams
      }).then(function(res){
        if (!res.ok) {
          return res.text().then(function(text){
            console.warn('Form POST not ok', res.status, text);
            throw new Error('HTTP ' + res.status + ': ' + (text || res.statusText));
          });
        }
        // Try parse JSON, otherwise accept as success
        return res.text().then(function(text){
          try { return JSON.parse(text); } catch(e){ return {ok:true, text: text}; }
        });
      }).then(function(data){
        console.log('Form success (form POST)', data);
        msgEl.textContent = 'Obrigado! Você foi adicionado à lista nossa lista, em breve entraremos em contato.';
        form.reset();
      }).catch(function(err){
        console.warn('Form POST failed, will try JSONP fallback', err);
        // Não mostrar mensagem de erro de CORS para o usuário — tente JSONP automaticamente
        msgEl.textContent = 'Aguarde, enviando...';
        console.log('Attempting JSONP fallback', endpoint, payload);
        jsonpRequest(endpoint, payload, function(data){
          console.log('JSONP success', data);
          msgEl.textContent = 'Obrigado! Você foi adicionado à lista nossa lista, em breve entraremos em contato.';
          form.reset();
        }, function(err2){
          console.error('JSONP fallback failed', err2);
          var userMsg = 'Erro ao enviar — tente novamente mais tarde.';
          if (err2.message && err2.message.indexOf('timeout') !== -1) userMsg = 'Tempo esgotado ao tentar enviar — tente novamente.';
          msgEl.textContent = userMsg;
        });
      }).finally(function(){ if (btn) btn.disabled = false; });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    $all('form[data-endpoint]').forEach(initForm);

    // If theme uses hydration / ajax content load, observe new nodes
    var mo = new MutationObserver(function(m){
      m.forEach(function(rec){
        rec.addedNodes && rec.addedNodes.forEach(function(n){
          if (!(n instanceof HTMLElement)) return;
          n.querySelectorAll && n.querySelectorAll('form[data-endpoint]').forEach(initForm);
        });
      });
    });
    mo.observe(document.body, {childList:true, subtree:true});
  });
})();